import { FESTIVAL_SORT, FESTIVAL_TYPE } from "../../types";
import { PRODUCT_SLUG, STATUS } from "@types";

export const layoutCardsCount = 32;

export const festivalStepsColors = [
  "#D3E7FF",
  "#FFD1CF",
  "#E9E2FF",
  "#FFE4A4",
  "#C3E7D8",
];

export const festivalStepLabel = {
  [FESTIVAL_TYPE.STEPPED_COUNT]: " آموزش ",
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: " هزار تومان ",
  [FESTIVAL_TYPE.WONDER]: undefined,
  [FESTIVAL_TYPE.PERCENT]: undefined,
};
export const festivalTitles = {
  [FESTIVAL_TYPE.WONDER]: {
    introTopBox: "فقط و فقط",
    introMiddleBox: "آموزش فرادرس",
    introBottomBox: "طــــــــــــرح",
    introTopBoxLabel: "هزار تومان",
  },
  [FESTIVAL_TYPE.PERCENT]: {
    introTitle: "به سوی مهر",
    introPercent: "۵۰ درصد",
  },
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: {
    introTopBox: "تخفیف تا",
    introMiddleBox: "ویـــــــــــــژه",
    introBottomBox: "طرح تخفیف ",
    introTopBoxLabel: "هزار تومان",
  },
  [FESTIVAL_TYPE.STEPPED_COUNT]: {
    introTopBox: "تخفیف تا",
    introMiddleBox: " ویـــــــــــــژه",
    introBottomBox: "طرح تخفیف ",
    introTopBoxLabel: "هزار تومان",
  },
};
export const festivalUnit = {
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: "مقدار",
  [FESTIVAL_TYPE.STEPPED_COUNT]: "تعداد",
  [FESTIVAL_TYPE.WONDER]: undefined,
  [FESTIVAL_TYPE.PERCENT]: undefined,
};

export const cardLabel = {
  [STATUS.PUBLISHING]: "نشر نهایی",
  [STATUS.EDITING]: "ویرایش و تدوین",
  [STATUS.PLANNING]: "برنامه‌ریزی اولیه",
  [STATUS.RECORDING]: "ضبط آموزش",
  [STATUS.START_RECORDING]: "هماهنگی شروع ضبط",
  [STATUS.QUALITY_INSPECTION]: "کنترل کیفی",
  [STATUS.UNPUBLISHED]: "",
  [STATUS.PUBLISHED]: "",
};

export const collectionList = [
  {
    title: "زبان انگلیسی",
    image: "https://cdn.faradars.org/wp-content/uploads/2022/12/07/english.svg",
    url: "/how-to-learn/english-language",
  },
  {
    title: "اکسل",
    image: "https://cdn.faradars.org/wp-content/uploads/2022/12/07/exel.svg",
    url: "/how-to-learn/microsoft-excel",
  },
  {
    title: "برنامه‌نویسی",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/07/programming.svg",
    url: "/how-to-learn/programming",
  },
  {
    title: "پایتون",
    image: "https://cdn.faradars.org/wp-content/uploads/2022/12/07/paython.svg",
    url: "/how-to-learn/python-programming",
  },
  {
    title: "آفیس",
    image: "https://faradars.org/wp-content/uploads/2024/08/06/office.svg",
    url: "/how-to-learn/microsoft-office",
  },
  {
    title: "طراحی و گرافیک",
    image: "https://cdn.faradars.org/wp-content/uploads/2022/12/07/graphic.svg",
    url: "/how-to-learn/photoshop-computer-design-and-graphics",
  },
  {
    title: "هوش مصنوعی",
    image: "https://cdn.faradars.org/wp-content/uploads/2022/12/07/ai.svg",
    url: "/how-to-learn/artificial-intelligence",
  },
  {
    title: "طراحی و برنامه ‌نویسی سایت",
    image: "https://faradars.org/wp-content/uploads/2024/08/06/web-design.svg",
    url: "/how-to-learn/web-design-and-programming",
  },
  {
    title: "وردپرس",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/12/wordpress(وردپرس).svg",
    url: "/how-to-learn/wordpress",
  },
  {
    title: "ارز دیجیتال",
    image:
      "https://faradars.org/wp-content/uploads/2024/08/06/digital-currency.svg",
    url: "/how-to-learn/digital-currency",
  },
  {
    title: "ریاضیات",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/07/mathematics.svg",
    url: "/how-to-learn/mathematics",
  },
  {
    title: "بورس و بازار سهام",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/07/exchange.svg",
    url: "/how-to-learn/stock-and-technical-analysis",
  },
  {
    title: "هنر",
    image: "https://cdn.faradars.org/wp-content/uploads/2022/12/07/art.svg",
    url: "/how-to-learn/art",
  },
  {
    title: "مهندسی برق",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/12/electricity(مهندسی-برق).svg",
    url: "/how-to-learn/electrical-engineering",
  },
  {
    title: "استارتاپ و کسب و کار",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/12/startup(استارتاپ-و-کسب-و-کار).svg",
    url: "/how-to-learn/startup-and-business",
  },
  {
    title: "مهندسی عمران",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/12/construction(مهندسی-عمران).svg",
    url: "/how-to-learn/civil-engineering",
  },
  {
    title: "مهندسی مکانیک",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/07/mechanic.svg",
    url: "/how-to-learn/mechanical-engineering",
  },
  {
    title: "مهندسی نرم‌افزار",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/07/software.svg",
    url: "/how-to-learn/computer-science-and-engineering",
  },
  {
    title: "مهندسی صنایع",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/12/industry(مهندسی-صنایع).svg",
    url: "/how-to-learn/industrial-engineering",
  },
  {
    title: "زبان",
    image: "https://faradars.org/wp-content/uploads/2024/08/06/languge.svg",
    url: "/how-to-learn/language-collection",
  },
  {
    title: "توسعه مهارت فردی",
    image: "https://faradars.org/wp-content/uploads/2024/08/06/development.svg",
    url: "/how-to-learn/development-of-individual-skills",
  },
  {
    title: "مدیریت",
    image:
      "https://cdn.faradars.org/wp-content/uploads/2022/12/07/management.svg",
    url: "/how-to-learn/management",
  },

  {
    title: "ویژه نوجوانان",
    image: "https://faradars.org/wp-content/uploads/2024/08/06/students.svg",
    url: "/how-to-learn/students-and-teenagers",
  },

  {
    title: "دروس دانشگاهی",
    image:
      "https://faradars.org/wp-content/uploads/2024/08/06/academic-cours.svg",
    url: "/how-to-learn/academic-courses",
  },
];

export const PRODUCT_SLUGS = [
  PRODUCT_SLUG.USER_RECOMMENDED_PRODUCTS,
  PRODUCT_SLUG.USER_RECENT_VIEW_PRODUCT,
  PRODUCT_SLUG.USER_FAVORITE_PRODUCTS,
] as const;

export const sortItems = [
  {
    id: FESTIVAL_SORT.MOST_POPULAR,
    label: "پرمخاطب‌ترین‌ها",
  },
  {
    id: FESTIVAL_SORT.NEWEST,
    label: "جدیدترین‌ها",
  },
];
